export default {
	edit: 'Modifier',
	delete: 'Supprimer',
	enable: 'Activer pour ce scénario',
	disable: 'Désactiver pour ce scénario',
	next_step: 'Étape suivante',
	skip: 'Passer',
	finish_review: 'Terminer la revue',
	skip_review: 'Passer la vérification',
	view: 'Voir les détails',
	close: 'Fermer',
	cancel: 'Annuler',
	confirm: 'Oui',
	send: 'Envoyer',
	clone: 'Cloner',
	open: 'Ouvrir',
	sign_out: 'Se déconnecter',
	search: 'Rechercher',
	save: 'Sauvegarder',
	sort_by_name: 'Trier par nom (A→Z)',
	sort_by_importance: 'Trier par importance (élevé→faible)',
	filter_positive: 'Filtrer les parties prenantes positives',
	filter_negative: 'Filtrer les parties prenantes négatives',
	export: {
		excel: 'Exporter en Excel',
		image: 'Exporter en image'
	},
	click_to_select: 'Cliquer pour sélectionner',
	click_to_drag: 'Glisser-déposer pour déplacer',
	confirm_drop: {
		message_baseline:
			'Vous modifiez la baseline, confirmez-vous les modifications ?',
		message_scenario:
			'Vous modifiez le scénario {{scenarioName}}, confirmez-vous les modifications ?',
		likelihood: 'Probabilité',
		impact: 'Impact',
		before: 'Avant',
		after: 'Après'
	}
};
